import { Component, ElementRef, EventEmitter, HostBinding, HostListener, inject, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'eca-zoom',
  templateUrl: './zoom.component.html',
  styleUrls: ['./zoom.component.scss']
})
export class ImageZoomComponent implements OnInit {
  private elementRef = inject(ElementRef);


  i = 0;
  scale = 1;
  initialScale = 1;
  element;
  elementTarget;
  elementPosition;
  parentElement;
  startX: number;
  startY: number;
  moveX = 0;
  moveY = 0;
  initialMoveX = 0;
  initialMoveY = 0;
  isZoomed = false;
  transitionDuration = 200;

  @Output() events: EventEmitter<any> = new EventEmitter<any>();

  @HostBinding('style.overflow') hostOverflow: string;

  @ViewChild('content', {static: true}) contentElement: ElementRef;

  ngOnInit() {
    this.element = this.contentElement.nativeElement;
    this.parentElement = this.elementRef.nativeElement;
    this.elementTarget = this.element.querySelector('*').tagName;

    this.setBasicStyles();

    this.element.ondragstart = () => false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(/* event: Event */): void {
    this.setImageWidth();
    this.transformElement(this.transitionDuration);
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    this.toggleZoom(event);
  }

  getDistance(touches: TouchList) {
    return Math.sqrt(Math.pow(touches[0].pageX - touches[1].pageX, 2) + Math.pow(touches[0].pageY - touches[1].pageY, 2));
  }

  getImageHeight(): number {
    return this.element.getElementsByTagName(this.elementTarget)[0].offsetHeight;
  }

  getImageWidth(): number {
    return this.element.getElementsByTagName(this.elementTarget)[0].offsetWidth;
  }

  setBasicStyles(): void {
    this.element.style.display = 'flex';
    this.element.style.height = '100%';
    this.element.style.alignItems = 'center';
    this.element.style.justifyContent = 'center';
    this.element.style.transformOrigin = '0 0';

    this.hostOverflow = 'hidden';

    this.setImageWidth();
  }

  setImageWidth(): void {
    const imgElement = this.element.getElementsByTagName(this.elementTarget);

    if (imgElement.length) {
      imgElement[0].style.maxWidth = '100%';
      imgElement[0].style.maxHeight = '100%';
    }
  }

  transformElement(duration: number = 50) {
    this.element.style.transition = `all ${duration}ms`;
    this.element.style.transform = `
            matrix(${Number(this.scale)}, 0, 0, ${Number(this.scale)}, ${Number(this.moveX)}, ${Number(this.moveY)})`;
  }

  public toggleZoom(event: any = false): void {
    this.isZoomed = !this.isZoomed;

    if (this.initialScale === 1) {
      this.scale = this.initialScale * 2;
      // this.initialMoveX - this.element.offsetWidth / 2;
      this.moveX = -event.offsetX;
      // this.initialMoveY - this.element.offsetHeight / 2;
      this.moveY = -event.offsetY;

      this.centeringImage();
      this.updateInitialValues();
      this.transformElement(this.transitionDuration);
      this.events.emit({type: 'zoom-in'});
    } else {
      this.resetScale();

      this.events.emit({type: 'zoom-out'});

      setTimeout(() => {
        this.events.emit({type: 'zoom-out-end'});
      }, this.transitionDuration);

    }
  }

  resetScale(): void {
    this.scale = 1;
    this.moveX = 0;
    this.moveY = 0;
    this.updateInitialValues();
    this.transformElement(this.transitionDuration);
  }

  updateInitialValues(): void {
    this.initialScale = this.scale;
    this.initialMoveX = this.moveX;
    this.initialMoveY = this.moveY;
  }

  centeringImage(): boolean {
    const img = this.element.getElementsByTagName(this.elementTarget)[0];
    const initialMoveX = this.moveX;
    const initialMoveY = this.moveY;

    if (this.moveY > 0) {
      this.moveY = 0;
    }
    if (this.moveX > 0) {
      this.moveX = 0;
    }

    if (img) {
      this.transitionYRestriction();
      this.transitionXRestriction();
    }
    if (img && this.scale < 1 && this.moveX < this.element.offsetWidth * (1 - this.scale)) {
      this.moveX = this.element.offsetWidth * (1 - this.scale);
    }
    return initialMoveX !== this.moveX || initialMoveY !== this.moveY;
  }

  transitionYRestriction(): void {
    const imgHeight = this.getImageHeight();

    if (imgHeight * this.scale < this.parentElement.offsetHeight) {
      this.moveY = (this.parentElement.offsetHeight - this.element.offsetHeight * this.scale) / 2;
    } else {
      const imgOffsetTop = ((imgHeight - this.element.offsetHeight) * this.scale) / 2;

      if (this.moveY > imgOffsetTop) {
        this.moveY = imgOffsetTop;
      } else if ((imgHeight * this.scale + Math.abs(imgOffsetTop) - this.parentElement.offsetHeight) + this.moveY < 0) {
        this.moveY = -(imgHeight * this.scale + Math.abs(imgOffsetTop) - this.parentElement.offsetHeight);
      }
    }
  }

  transitionXRestriction(): void {
    const imgWidth = this.getImageWidth();

    if (imgWidth * this.scale < this.parentElement.offsetWidth) {
      this.moveX = (this.parentElement.offsetWidth - this.element.offsetWidth * this.scale) / 2;
    } else {
      const imgOffsetLeft = ((imgWidth - this.element.offsetWidth) * this.scale) / 2;

      if (this.moveX > imgOffsetLeft) {
        this.moveX = imgOffsetLeft;
      } else if ((imgWidth * this.scale + Math.abs(imgOffsetLeft) - this.parentElement.offsetWidth) + this.moveX < 0) {
        this.moveX = -(imgWidth * this.scale + Math.abs(imgOffsetLeft) - this.parentElement.offsetWidth);
      }
    }
  }

}
